import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'reactstrap';

import { copyToClipBoard } from '../../utils/';

const TextCurtain = ({ title = null, text = '..........', canCopy = true }) => {
  // If the text is too big, limits the displayed password pattern to 10 characters
  const convertedText =
    text.length > 10 ? '..........'.replace(/./g, '•') : text.replace(/./g, '•');
  const { t: translate } = useTranslation();
  const [hidden, setHidden] = useState(true);
  const [hiddenText, setHiddenText] = useState(convertedText);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <div className="text-curtain-wrapper">
      {title !== null ? <p className="text-curtain-title">{`${title}: `}</p> : null}

      <div className="text-curtain-field">
        <i
          className={`text-curtain-icon bx ${hidden ? 'bx-show' : 'bx-hide'} me-3`}
          onClick={() => setHidden(!hidden)}
        />
        {hidden ? (
          <p className="text-curtain-text-hidden">{hiddenText}</p>
        ) : (
          <p className={`text-curtain-text ${canCopy ? 'can-select' : 'cant-select'}`}>{text}</p>
        )}
      </div>

      {canCopy ? (
        <>
          <i
            id="btn-code-copy"
            className="text-curtain-icon bx bx-copy ms-2"
            onClick={(event) => {
              copyToClipBoard(event, text);
              setTooltipOpen(true);
              setTimeout(() => {
                setTooltipOpen(false);
              }, 2000);
            }}
          />
          <Tooltip target="btn-code-copy" isOpen={tooltipOpen} delay={0}>
            {translate('Copied')}
          </Tooltip>
        </>
      ) : null}
    </div>
  );
};

TextCurtain.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  canCopy: PropTypes.bool,
};

export default TextCurtain;
